export function get_time()
{
	// Constants that won't change through the script
	const clock = document.querySelector('.clock-inner');
	const hourhand = document.querySelector('.hour');
	const minutehand = document.querySelector('.minute');
	const secondhand = document.querySelector('.second');

	let day = $(clock).attr('data-day');
	let hr  = $(clock).attr('data-hour');
	let min = $(clock).attr('data-min');
	let sec = $(clock).attr('data-sec');

	day = parseInt(day);
	hr  = parseInt(hr);
	min = parseInt(min);
	sec = parseInt(sec);

	// Combined min + hours for easier buisness hours function
	let hrMin = hr + (min / 60);

	//Run an ajax request to get the latest time
	let data = {
		action: 'getCurrentTime',
	};

	$.post(Ajax.url, data, function(res)
	{
		res = $.parseJSON(res);
		day = parseInt(res.day);
		hr  = parseInt(res.hour);
		min = parseInt(res.minute);
		sec = parseInt(res.second);

		// Combined min + hours for easier buisness hours function
		hrMin = hr + (min / 60);

		var interval = setInterval(run_clock, 1000);
	});

	//Get php data-attributes, js will offset this
	function run_clock()
	{

		sec++;

		if (sec >= 60)
		{
			min++;
			sec = 1;
		}

		if (min >= 60)
		{
			hr++;
			min = 0;
		}

		if (hr >= 24)
		{
			hr = 0;
		}

		let hrMin = hr + (min / 60);

		let hrPosition = hr * 360 / 12 + ((min * 360 / 60) / 12) ;
		let minPosition = (min * 360 / 60) + (sec* 360 / 60) / 60;
		let secPosition = sec * 360 / 60;

		//Then we need to apply these numbers as degrees in the inline styles for transform on each of the objects.
		hourhand.style.transform = 'translate(-50%, -50%) rotate(' + hrPosition + 'deg)';
		minutehand.style.transform = 'translate(-50%, -50%) rotate(' + minPosition + 'deg)';
		secondhand.style.transform = 'translate(-50%, -50%) rotate(' + secPosition + 'deg)';
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/clock.js